import { message } from "antd"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import { IDynamicTargetAcos } from "../types/sbCampaignApi.types"
import { ITargetDataForTable } from "../types/sbTarget.types"
import { ITargetData } from "../types/sbTargetApi.types"
import { useMetrics } from "../../../hooks/useMetrics"
import { applyTargetMetrics, findCampaignAov } from "./helpers/targetMetrics.helper"

export const UseTargetsMetrics = (campaignName: string) => {
  const { calcLimitedCPC, calcTargetCPC, calcBestCPC } = useMetrics()
  const { campaignData } = useTypedSelector((select) => select.sponsoredBrands)

  function calcTargetACOS(targets: ITargetDataForTable[]): ITargetDataForTable[] {
    return targets.map((target) => {
      const name = campaignName.split(/\s+/)
      const isWordIncludedInObject = (word, obj) => {
        return word.type.toLowerCase().includes(obj.toLowerCase())
      }
      let findedTargetAcos = campaignData.defaultTargetAcos.find((word) =>
        name.some((obj) => isWordIncludedInObject(word, obj))
      )

      if (findedTargetAcos == undefined) {
        findedTargetAcos = campaignData.defaultTargetAcos.find((x) => x.type == "All other")
      }

      if (findedTargetAcos && findedTargetAcos.dynamicTarget === true) {
        return {
          ...target,
          targetAcos: findAcos(findedTargetAcos?.dynamicTargetAcos, target.cvr),
        }
      } else {
        return {
          ...target,
          targetAcos: findedTargetAcos?.targetAcos || 0,
        }
      }
    })
  }

  function findAcos(records: IDynamicTargetAcos[], givenValue: number) {
    for (const record of records) {
      if (record.from <= givenValue && givenValue <= record.to) {
        return record.Acos
      }
    }
    return 0
  }

  function applyMetrics(targets: ITargetDataForTable[]): ITargetDataForTable[] {
    const aov = findCampaignAov(campaignData.getAOVData?.aovs, campaignName)
    if (!aov) {
      message.error("AOV not found")
      return []
    }

    return applyTargetMetrics(
      targets,
      {
        defaultBid: campaignData.defaultBid,
        minTargetCPC: campaignData.minTargetCPC,
        maxTargetCPC: campaignData.maxTargetCPC,
        limitedCPCConditions: campaignData.limitedCPCValue?.conditions ?? null,
        aovValue: aov.value,
      },
      { calcTargetCPC, calcBestCPC, calcLimitedCPC }
    )
  }

  function calcAllMetrics(targetData: ITargetData[]): ITargetDataForTable[] {
    return applyMetrics(calcTargetACOS(buildTargetsForTable(targetData)))
  }

  function buildTargetsForTable(targetData: ITargetData[]) {
    const targetForTable: ITargetDataForTable[] = targetData.map((target) => {
      return {
        ...target,
        targetCPC: 0,
        bestCPC: 0,
        deflatedCPC: null,
      }
    })
    return targetForTable
  }

  function calcMetricsBeforeUpdatedAcos(targetData: ITargetDataForTable[]): ITargetDataForTable[] {
    return applyMetrics(targetData)
  }

  return {
    calcTargetACOS,
    calcAllMetrics,
    calcMetricsBeforeUpdatedAcos,
    buildTargetsForTable,
  }
}
